'use client';

import { c as _c } from "react/compiler-runtime";
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { Fragment, useMemo, useState } from 'react';
import { useHasMounted } from '@src/hooks/useHasMounted';
import { useLocale } from '@src/i18n/LocaleProvider';
import { getLocales } from '@src/i18n/locale.util';
import { cn } from '@src/utils/tailwind';
import { LocalizedLink } from '../LocalizedLink/LocalizedLink';
import { getLocaleSwitchHref, readAlternateHref } from './LocaleSwitcher.util';
export const LocaleSwitcher = () => {
  const $ = _c(26);
  const {
    locale
  } = useLocale();
  const [localeSelected, setLocaleSelected] = useState(locale);
  const isMounted = useHasMounted();
  const pathname = usePathname();
  let t0;
  if ($[0] !== localeSelected.code || $[1] !== pathname) {
    let t1;
    if ($[3] !== localeSelected.code) {
      t1 = l => l.code !== localeSelected.code;
      $[3] = localeSelected.code;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = getLocales({
      path: pathname
    }).filter(t1);
    $[0] = localeSelected.code;
    $[1] = pathname;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const localesSorted = t0;
  let t1;
  if ($[5] !== isMounted || $[6] !== localesSorted) {
    t1 = () => {
      if (!isMounted) {
        return null;
      }
      return localesSorted.map(l_0 => {
        const href = getLocaleSwitchHref({
          search: window.location.search,
          origin: window.location.origin,
          targetLocale: l_0,
          alternateHref: readAlternateHref(`${l_0.lang}-${l_0.countryCodeLowercase}`)
        });
        return <MenuItem key={l_0.switcherLabel}><LocalizedLink useNextLink={false} href={href} targetCountry={l_0.countryCodeLowercase} targetLanguage={l_0.lang} onClick={() => setLocaleSelected(l_0)} className="flex w-full cursor-pointer appearance-none items-center gap-3 rounded-md bg-bodi-white px-3 py-2 text-body-sm hover:bg-bodi-accent-bright-500"><Image priority={true} src={l_0.flag} width={20} height={20} alt="flag" className="shrink-0" /><p className="min-w-fit">{l_0.switcherLabel}</p></LocalizedLink></MenuItem>;
      });
    };
    $[5] = isMounted;
    $[6] = localesSorted;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const renderOptions = t1;
  let t2;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("relative inline-block text-left");
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("group z-20 inline-flex w-full items-center rounded-md px-4 py-2 text-body-sm transition-all", "data-open:rounded-t-none data-open:bg-bodi-white data-open:font-semibold data-open:text-bodi-black");
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== localeSelected.flag) {
    t4 = <Image priority={true} src={localeSelected.flag} width={20} height={20} alt="flag" className="shrink-0" />;
    $[10] = localeSelected.flag;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== localeSelected.switcherLabel) {
    t5 = <p className="mr-1 ml-3">{localeSelected.switcherLabel}</p>;
    $[12] = localeSelected.switcherLabel;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChevronDownIcon className="w-6 shrink-0 transition-all group-data-open:rotate-180" />;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t5) {
    t7 = <MenuButton className={t3}>{t4}{t5}{t6}</MenuButton>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("absolute bottom-full left-0 z-10 w-full origin-bottom-right rounded-t-md bg-white text-bodi-black transition-all duration-150 focus:outline-none", "translate-y-0 opacity-100", "data-closed:translate-y-4 data-closed:opacity-0 data-enter:ease-out data-leave:ease-in");
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== renderOptions) {
    t9 = renderOptions();
    $[19] = renderOptions;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t9) {
    t10 = <Transition as={Fragment}><MenuItems className={t8}><div className="p-1 pb-0">{t9}</div></MenuItems></Transition>;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t7) {
    t11 = <Menu as="div" className={t2}>{t7}{t10}</Menu>;
    $[23] = t10;
    $[24] = t7;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
};